module.exports = __webpack_public_path__ + "static/media/slider3.1686f401.JPG";